import loadable from '@loadable/component';

export const ShortlistSiteWrapper = loadable(
  () => import(/* webpackChunkName: "shortlist-site" */ './ShortlistSiteWrapper'),
);
